module.exports = __webpack_public_path__ + "static/media/galeryVinyl1.80528016.jpg";